import React from 'react';

import axios from '../../../../services/MyAxios';
import { API_CASINO_DASHBOARD_WAGERED_LAST_WEEKS } from '../../Helpers/CrmApiUrls';
import LinearBlock from '../Elements/LinearBlock';

const numberOfWeeks = 8;

export default function WageredLinear() {
    const axiosRequestCallback = (formattedStartDate: string, formattedEndDate: string) => {
        return axios.get(API_CASINO_DASHBOARD_WAGERED_LAST_WEEKS, {
            params: {
                start: formattedStartDate,
                end: formattedEndDate,
            },
        });
    };

    return (
        <LinearBlock
            title={`Wagered last ${numberOfWeeks} weeks`}
            axiosRequestCallback={axiosRequestCallback}
            numberOfWeeks={numberOfWeeks}
            label="Sum of bets"
        />
    );
}
